import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sun, SunMedium, Moon, ShieldCheck, Loader2, CheckCircle2 } from 'lucide-react';
import SastraLogo from '../../FrontOffice/components/SastraLogo';
import './WelcomeAdmin.css';

const WelcomeAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const target = location.state?.target || '/dashboard';
  
  const [greeting, setGreeting] = useState('');
  const [subGreeting, setSubGreeting] = useState('');
  const [periodClass, setPeriodClass] = useState('morning');
  const [timeIcon, setTimeIcon] = useState(null);

  useEffect(() => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      setGreeting("Bonjour");
      setSubGreeting("Bienvenue dans votre espace d'administration. Nous vous souhaitons une excellente journée et une session productive.");
      setPeriodClass("morning");
      setTimeIcon(<Sun className="w-8 h-8" strokeWidth={2} />);
    } else if (hour >= 12 && hour < 18) {
      setGreeting("Bonjour");
      setSubGreeting("Bienvenue dans votre espace d'administration. Nous vous souhaitons un très bon après-midi et une session fructueuse.");
      setPeriodClass("afternoon");
      setTimeIcon(<SunMedium className="w-8 h-8" strokeWidth={2} />);
    } else {
      setGreeting("Bonsoir");
      setSubGreeting("Bienvenue dans votre espace d'administration. Nous vous souhaitons une excellente soirée et un travail serein.");
      setPeriodClass("evening");
      setTimeIcon(<Moon className="w-8 h-8" strokeWidth={2} />);
    }

    // Auto navigate after ~2.8 seconds
    const timer = setTimeout(() => {
      navigate(target, { replace: true });
    }, 2800);

    return () => clearTimeout(timer);
  }, [navigate, target]);

  return (
    <div className="welcome-admin-overlay" role="region" aria-label="Écran d'accueil administrateur">
      {/* Background ambient lighting */}
      <div className="welcome-glow-orb welcome-glow-orb-1" />
      <div className="welcome-glow-orb welcome-glow-orb-2" />

      {/* Main glassmorphic card */}
      <div className="welcome-admin-card">
        <div className="welcome-card-accent-line" />

        {/* Header with Logo and Admin Badge */}
        <div className="welcome-brand-header">
          <div className="welcome-brand-logo">
            <SastraLogo size={32} />
          </div>
          <div className="welcome-badge-admin">
            <span className="welcome-status-dot" />
            <ShieldCheck size={14} className="welcome-badge-icon" />
            <span>ESPACE ADMINISTRATEUR</span>
          </div>
        </div>

        {/* Central Icon */}
        <div className={`welcome-icon-box ${periodClass}`} aria-hidden="true">
          {timeIcon}
        </div>

        {/* Greeting & Message */}
        <h1 className="welcome-title">{greeting}</h1>
        <p className="welcome-subtitle">{subGreeting}</p>

        {/* Preparation & Progress bar */}
        <div className="welcome-progress-section">
          <div className="welcome-progress-track">
            <div className="welcome-progress-fill" />
          </div>
          <div className="welcome-status-message" role="status" aria-live="polite">
            <Loader2 size={16} className="welcome-spinner-mini" />
            <span>Préparation de votre espace de travail sécurisé…</span>
          </div>
        </div>

        {/* Signature */}
        <div className="welcome-footer">
          <CheckCircle2 size={14} className="welcome-footer-icon" />
          <span>Session certifiée — <strong>L'Équipe IT Sastra Energy</strong></span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeAdmin;
